import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fifa',
  templateUrl: './fifa.component.html',
  styleUrls: ['./fifa.component.css']
})
export class FifaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
